// Components/ui
import subsectionBodyContainerStyle from './style';
import { Box } from '@mui/material';
// Types
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  variant?: 'large' | 'default';
};

const SubsectionBodyContainer = ({ children }: Props) => {
  return (
    <Box
      sx={{
        ...subsectionBodyContainerStyle.container,
      }}
    >
      {children}
    </Box>
  );
};

export default SubsectionBodyContainer;
